import { render, staticRenderFns } from "./partnerTag.vue?vue&type=template&id=45f1a1b1&scoped=true"
import script from "./partnerTag.vue?vue&type=script&lang=js"
export * from "./partnerTag.vue?vue&type=script&lang=js"
import style0 from "./partnerTag.vue?vue&type=style&index=0&id=45f1a1b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f1a1b1",
  null
  
)

export default component.exports